<template>
  <form class="form" @submit.prevent="createUpdateVin">
    <fieldset class="fieldset">
      <legend class="legend">Informations</legend>

      <!-- Appellation -->
      <div class="field">
        <label class="label" for="appellation">Appellation :</label>
        <input type="text" class="input" v-model="vin.appellation" id="appellation" required />
      </div>

      <!-- Appellation -->
      <div class="field">
        <label class="label" for="temperature_vin">Température du vin :</label>
        <input type="text" class="input" v-model="vin.temperature_vin" id="temperature_vin" />
      </div>

      <!-- Obversations -->
      <div class="field">
        <label class="label label--top" for="observations">Observations :</label>
        <textarea class="input" rows="5" v-model="vin.observations" id="observations"></textarea>
      </div>
    </fieldset>

    <fieldset class="fieldset">
      <div class="fields">
        <!-- Dégro -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.degro" id="degro" />
          <label class="label" for="degro">Dégro</label>
        </div>

        <!-- Cubi -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.cubi" id="cubi" />
          <label class="label" for="cubi">Cubi</label>
        </div>

        <!-- Mise -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.mise" id="mise" />
          <label class="label" for="mise">Mise</label>
        </div>

        <!-- Mise client -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.mise_client" id="mise_client" />
          <label class="label" for="mise_client">Mise client</label>
        </div>
      </div>
    </fieldset>

    <fieldset class="fieldset">
      <div class="fields">
        <!-- Vin bio -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.vin_bio" id="vin_bio" />
          <label class="label" for="vin_bio">Vin bio</label>
        </div>

        <!-- Vin sans souffre -->
        <div class="field">
          <input
            type="checkbox"
            class="checkbox"
            v-model="vin.vin_sans_souffre"
            id="vin_sans_souffre"
          />
          <label class="label" for="vin_sans_souffre">Vin sans souffre</label>
        </div>

        <!-- Filtrage inertage -->
        <div class="field">
          <input
            type="checkbox"
            class="checkbox"
            v-model="vin.filtrage_inertage"
            id="vin_sans_souffre"
          />
          <label class="label" for="vin_sans_souffre">Filtrage s/inertage</label>
        </div>

        <!-- Vin collé -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.vin_colle" id="vin_colle" />
          <label class="label" for="vin_colle">Vin collé</label>
        </div>
      </div>
    </fieldset>

    <fieldset class="fieldset">
      <legend class="legend">Cuvée</legend>

      <!-- Cuvée -->
      <div class="field">
        <label class="label" for="cuvee">Cuvée :</label>
        <input type="text" class="input" v-model="vin.cuvee" id="cuvee" />
      </div>

      <!-- Couleur -->
      <div class="field">
        <label class="label" for="couleur">Couleur :</label>
        <input type="text" class="input" v-model="vin.couleur" id="couleur" />
      </div>

      <!-- Cuve de départ -->
      <div class="field">
        <label class="label" for="cuve_depart">Cuve de départ :</label>
        <input type="number" min="0" class="input" v-model="vin.cuve_depart" id="cuve_depart" />
      </div>

      <!-- Cuve de réception -->
      <div class="field">
        <label class="label" for="cuve_reception">Cuve de réception :</label>
        <input
          type="number"
          min="0"
          class="input"
          v-model="vin.cuve_reception"
          id="cuve_reception"
        />
      </div>
    </fieldset>

    <fieldset class="fieldset">
      <legend class="legend">Filtration</legend>
      <div class="fields">
        <!-- K1 -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.filtration_k1" id="k1" />
          <label class="label" for="k1">K1</label>
        </div>

        <!-- K2 -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.filtration_k2" id="k2" />
          <label class="label" for="k2">K2</label>
        </div>

        <!-- TG -->
        <div class="field">
          <input type="checkbox" class="checkbox" v-model="vin.filtration_tg" id="tg" />
          <label class="label" for="tg">TG</label>
        </div>
      </div>
    </fieldset>

    <fieldset class="fieldset">
      <legend class="legend">Gaz</legend>
      <div class="fields">
        <!-- Début gaz -->
        <div class="field">
          <label class="label" for="gaz_debut">Début :</label>
          <input type="text" class="input" v-model="vin.gaz_debut" id="gaz_debut" />
        </div>

        <!-- Fin gaz -->
        <div class="field">
          <label class="label" for="gaz_fin">Fin :</label>
          <input type="text" class="input" v-model="vin.gaz_fin" id="gaz_fin" />
        </div>
      </div>
    </fieldset>

    <fieldset class="fieldset">
      <legend class="legend">PRPo</legend>
      <div class="fields">
        <!-- Présence d'allergènes -->
        <div class="field">
          <input
            type="checkbox"
            class="checkbox"
            v-model="vin.presence_allergenes"
            id="presence_allergenes"
          />
          <label class="label" for="presence_allergenes"
            >Présence d'allergènes autres que SO2 (PRPo1)</label
          >
        </div>

        <!-- Précision -->
        <div class="field">
          <label class="label" for="presence_allergenes_precision">Préciser :</label>
          <input
            type="text"
            class="input"
            v-model="vin.presence_allergenes_precision"
            id="presence_allergenes_precision"
            :disabled="!vin.presence_allergenes"
          />
        </div>

        <!-- Analyse fournie -->
        <div class="field">
          <input
            type="checkbox"
            class="checkbox"
            v-model="vin.analyse_fournie"
            id="analyse_fournie"
          />
          <label class="label" for="analyse_fournie">Analyse fournie (PRPo2)</label>
        </div>
      </div>
    </fieldset>

    <fieldset class="fieldset">
      <legend class="legend">Concentration des produits</legend>
      <div class="field" v-for="produit in produits" :key="produit.id">
        <label class="label" :for="produit.id">{{ produit.nom }} :</label>
        <input
          type="text"
          class="input"
          v-model="vin.presence_allergenes_precision"
          :id="produit.id"
        />
      </div>
    </fieldset>

    <div class="buttons">
      <ButtonElement type="submit" color="success" :icon="PhCheck">Valider</ButtonElement>
    </div>
  </form>
</template>

<script setup lang="ts">
import type { OrdreFabricationGet, OrdreFabricationVin } from '@/interfaces/OrdreFabrication.ts'
import type { PropType } from 'vue'
import type { ProduitFiltrationList } from '@/interfaces/ProduitFiltrationList.ts'
import { PhCheck } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'

const showForm = defineModel<boolean>('showForm', { required: true })
const vin = defineModel<OrdreFabricationVin>('vin', { required: true })
const ordreFabrication = defineModel<OrdreFabricationGet>('ordreFabrication', { required: true })

defineProps({
  produits: {
    type: Array as PropType<ProduitFiltrationList[]>,
    required: true,
  },
})

function createUpdateVin() {
  // crée ou modifie un vin
  if (ordreFabrication.value.id) {
    // avec un OF existant
    // TODO
  } else {
    // avec un nouvel OF
    if (vin.value.id) {
      // avec un vin déjà existant
      const index = ordreFabrication.value.vins.indexOf(vin.value)
      ordreFabrication.value.vins.splice(index, 1, vin.value)
    } else {
      // avec un nouveau vin
      vin.value.id = crypto.randomUUID()
      vin.value.ordre = ordreFabrication.value.vins.length + 1
      ordreFabrication.value.vins.push(vin.value)
    }
  }
  // on masque le formulaire
  showForm.value = false
}
</script>
